/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Col,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import FormBlock from 'loracoms/FormBlock';
import ControlTips from 'loracoms/ControlTips';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import deviceActions from 'loraactions/device';
import { isInteger } from 'lorautils/checkers/numbers';


const propTypes = {
  sent: React.PropTypes.object.isRequired,
  intl: React.PropTypes.any.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendCmd: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  getMacLog: React.PropTypes.func.isRequired,
};

class LinkADRReq extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'datarate')
          .add('FE_EMPTY', 'txpower')
          .add('FE_EMPTY', 'chmask')
          .add('FE_EMPTY', 'chmaskcntl')
          .add('FE_EMPTY', 'nbtrans')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.macview');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeDataRate = this.handleChangeDataRate.bind(this);
    this.handleChangeTxPower = this.handleChangeTxPower.bind(this);
    this.handleChangeChMask = this.handleChangeChMask.bind(this);
    this.handleChangeChMaskCntl = this.handleChangeChMaskCntl.bind(this);
    this.handleChangeNbtrans = this.handleChangeNbtrans.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { sent } = nextProps;
    let { errors } = this.state;

    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'failure') {
        errors = errors.add(sent.error.code, 'submit');
        this.setState({ errors });
      }
      if (sent.status === 'success') {
        const { getTxSize, getMacLog, deviceId } = nextProps;
        getTxSize(deviceId);
        getMacLog(deviceId);
      }
    }
  }

  handleChangeDataRate(e) {
    const datarate = e.target.value.trim();
    this.setState({ datarate });

    const { errors } = this.state;

    if (datarate === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'datarate') });
      return;
    }
    if (!isInteger(datarate, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'datarate') });
      return;
    }
    this.setState({ errors: errors.remove('datarate') });
  }

  handleChangeTxPower(e) {
    const txpower = e.target.value.trim();
    this.setState({ txpower });

    const { errors } = this.state;

    if (txpower === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'txpower') });
      return;
    }
    if (!isInteger(txpower, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'txpower') });
      return;
    }
    this.setState({ errors: errors.remove('txpower') });
  }

  handleChangeChMask(e) {
    const chmask = e.target.value.trim();
    this.setState({ chmask });

    const { errors } = this.state;

    if (chmask === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chmask') });
      return;
    }
    if (!isInteger(chmask, { min: 0, max: 65535 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chmask') });
      return;
    }
    this.setState({ errors: errors.remove('chmask') });
  }

  handleChangeChMaskCntl(e) {
    const chmaskcntl = e.target.value.trim();
    this.setState({ chmaskcntl });

    const { errors } = this.state;

    if (chmaskcntl === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'chmaskcntl') });
      return;
    }
    if (!isInteger(chmaskcntl, { min: 0, max: 7 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'chmaskcntl') });
      return;
    }
    this.setState({ errors: errors.remove('chmaskcntl') });
  }

  handleChangeNbtrans(e) {
    const nbtrans = e.target.value.trim();
    this.setState({ nbtrans });

    const { errors } = this.state;

    if (nbtrans === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'nbtrans') });
      return;
    }
    if (!isInteger(nbtrans, { min: 0, max: 15 })) {
      this.setState({ errors: errors.add('FE_INVALID', 'nbtrans') });
      return;
    }
    this.setState({ errors: errors.remove('nbtrans') });
  }

  handleSubmit(e) {
    this.setState({ submitted: true });
    e.preventDefault();

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendCmd } = this.props;
    const { datarate, txpower, chmask, chmaskcntl, nbtrans } = this.state;
    sendCmd(deviceId, {
      datarate,
      txpower,
      chmask,
      chmaskcntl,
      nbtrans,
    });
  }

  render() {
    const {
      sentStatus = '',
      datarate = '',
      txpower = '',
      chmask = '',
      chmaskcntl = '',
      nbtrans = '',
      errors,
      submitted = false,
    } = this.state;

    return (
      <Form horizontal onSubmit={this.handleSubmit}>
        <FormGroup validationState={submitted && errors.has('datarate') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">DataRate</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={datarate}
              placeholder={this.intlMsg.msg('linkadrreq.datarate.placeholder')}
              onChange={this.handleChangeDataRate}
            />
            <ControlTips
              show={submitted && errors.has('datarate')}
              message={this.intlMsg.errorMsg(errors.get('datarate'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('txpower') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">TX Power</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={txpower}
              placeholder={this.intlMsg.msg('linkadrreq.txpower.placeholder')}
              onChange={this.handleChangeTxPower}
            />
            <ControlTips
              show={submitted && errors.has('txpower')}
              message={this.intlMsg.errorMsg(errors.get('txpower'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('chmask') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">ChMask</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={chmask}
              placeholder={this.intlMsg.msg('linkadrreq.chmask.placeholder')}
              onChange={this.handleChangeChMask}
            />
            <ControlTips
              show={submitted && errors.has('chmask')}
              message={this.intlMsg.errorMsg(errors.get('chmask'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('chmaskcntl') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">ChMaskCntl</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={chmaskcntl}
              placeholder={this.intlMsg.msg('linkadrreq.chmaskcntl.placeholder')}
              onChange={this.handleChangeChMaskCntl}
            />
            <ControlTips
              show={submitted && errors.has('chmaskcntl')}
              message={this.intlMsg.errorMsg(errors.get('chmaskcntl'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('nbtrans') ? 'error' : undefined}>
          <Col md={3}>
            <ControlLabel bsClass="aisz-control-label">NbTrans</ControlLabel>
          </Col>
          <Col md={6}>
            <FormControl
              bsClass="aisz-form-control-f"
              value={nbtrans}
              placeholder={this.intlMsg.msg('linkadrreq.nbtrans.placeholder')}
              onChange={this.handleChangeNbtrans}
            />
            <ControlTips
              show={submitted && errors.has('nbtrans')}
              message={this.intlMsg.errorMsg(errors.get('nbtrans'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <RichButton
              status={sentStatus}
              states={[{
                status: 'default',
                label: this.intlMsg.msg('submit'),
                style: 'primary',
                type: 'submit',
              }, {
                status: 'success',
                label: this.intlMsg.msg('submit.success'),
                style: 'success',
                timer: () => this.setState({ sentStatus: '' }),
              }, {
                status: 'failure',
                label: this.intlMsg.msg('submit.failure'),
                style: 'danger',
                timer: () => this.setState({ sentStatus: '' }),
              }]}
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={3} md={6}>
            <FormBlock
              show={errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

LinkADRReq.propTypes = propTypes;

const mapStateToProps = state => ({
  sent: state.device.sendLinkADRReq,
});

const mapDispatchToProps = {
  sendCmd: deviceActions.sendLinkADRReq,
  getTxSize: deviceActions.getMacTxSize,
  getMacLog: deviceActions.getMacLog,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(LinkADRReq));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/MacView/coms/LinkADRReq.jsx